import { useHistory } from 'react-router-dom'

const History = () => {
  const history = useHistory()
  let prevPath = ''
  history.listen((location) => {
    if (location.pathname !== prevPath) {
      prevPath = location.pathname
      window.analytics.page()
    }
  })
  return <></>
}

export default History
